import { Col } from "reactstrap";
import { dynamicAPIImage } from "../../../../Utils";
import { useMutation, useQueryClient, useQuery } from "@tanstack/react-query";
import { useState, useEffect } from "react";
import { H5, Image, LI, P, UL, Btn } from "../../../../AbstractElements";
import ScrollBar from "react-perfect-scrollbar";
import DOMPurify from "dompurify";
import { useAppSelector } from "../../../../ReduxToolkit/Hooks";
import Swal from "sweetalert2";
import { Trash2 } from "react-feather";

//TYPE
import { ViewEmployeeNotesByEmpNo } from "../../../../Types/Employee/EmployeeNotes";
import { CRUDPermissions } from "../../../../Types/Common/Access";

//SERVICES
import {
  VIEW_EMPNOTES_QUERY_KEY,
  employeeNotesService,
} from "../../../../Services/EmployeeNoteServices";

interface EmployeeProfileProps {
  EmpNo: string;
  access: CRUDPermissions;
}

const Remarks: React.FC<EmployeeProfileProps> = ({ EmpNo, access }) => {
  const [isRowLoading, setIsRowLoading] = useState<boolean>(false);
  const queryClient = useQueryClient();
  const { data: noteData = [], isLoading: isFetching } = useQuery<
    ViewEmployeeNotesByEmpNo[]
  >({
    queryKey: [...VIEW_EMPNOTES_QUERY_KEY, EmpNo],
    queryFn: () =>
      employeeNotesService.ViewEmployeeNotesByEmpno(EmpNo as string),
  });
  const user = useAppSelector((state) => state.auth.user);

  const handleDelete = (id: number) => {
    Swal.fire({
      icon: "question",
      title: `Delete Remark`,
      html: `Are you sure you want to delete this remark?`,
      showCancelButton: true,

      confirmButtonText: '<i class="fa fa-trash"></i> Delete Remark',
      cancelButtonText: '<i class="fa fa-times"></i> Cancel',

      confirmButtonColor: "#4e73df", // Primary
      cancelButtonColor: "#dc3545", // Danger
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Deleting Remark...",
          text: "Please wait while your remarks is being deleted.",
          allowOutsideClick: false,
          allowEscapeKey: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        toggleMutation.mutate(id);
      }
    });
  };

  const toggleMutation = useMutation({
    mutationFn: employeeNotesService.toggleStatus,
    onSuccess: async (variables: { id: number; status_label: string }) => {
      queryClient.invalidateQueries();
      Swal.close();
      Swal.fire({
        allowOutsideClick: false,
        allowEscapeKey: false,
        icon: "success",
        title: "Transaction Successful",
        text: "Remarks has been deleted successfully",
        confirmButtonColor: "#4e73df",
      });
      setIsRowLoading(false);
    },
    onError: (error: any) => {
      Swal.close();
      Swal.fire({
        icon: "error",
        title: "Transaction Failed",
        text:
          error.response?.data?.message ||
          "Failed to Delete Remark please reload and try again.",
        confirmButtonColor: "#4e73df",
      });
      setIsRowLoading(false);
    },
  });

  return (
    <Col sm="12">
      <br></br>
      <ScrollBar className="vertical-scroll custom-container border shadow-sm rounded p-2 mb-2">
        <div className="msger-chat" style={{ height: "700px" }}>
          <UL className="simple-list mt-4 mx-4">
            {noteData?.map((item, index) => (
              <LI
                key={index}
                className=" rounded-3 shadow-sm bg-white p-3 mt-3"
              >
                <div className="d-flex">
                  <Image
                    className="rounded-square border"
                    width={60}
                    height={60}
                    src={
                      dynamicAPIImage(item.profile_url) ||
                      "user-profile/default.png"
                    }
                    alt="Profile Picture"
                  />

                  <div className="flex-grow-1 ms-3">
                    {/* Header */}
                    <div className="d-flex justify-content-between align-items-start">
                      <div>
                        <H5 className="mb-1 fw-semibold">
                          {item.created_by_user}
                        </H5>

                        <P>{"( " + item.created_date + " )"}</P>
                      </div>

                      {user?.id === item.created_by &&
                        item.origin === "EMP" &&
                        access.update && (
                          <div className="btn-group btn-group-sm">
                            <Btn
                              size="sm"
                              color="danger"
                              className="px-2"
                              onClick={() => handleDelete(item.id)}
                            >
                              <Trash2 size={11} /> Delete
                            </Btn>
                          </div>
                        )}
                    </div>
                  </div>
                </div>
                {/* Note */}
                <div className="border-top p-3 mt-3">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(item.notes),
                    }}
                  />
                </div>
              </LI>
            ))}
            <LI>
              <center>
                <br></br>*** Nothing Follows ***
              </center>
            </LI>
          </UL>
        </div>
      </ScrollBar>
    </Col>
  );
};
export default Remarks;
